<template>
  <div>
    <CRow>
      <CCol col="12" xl="12">
        <CCard>
          <PageTitle title="Entries" :rows="rows" />
          <CCardBody>
            <SubNav :csv_export="csv_export" />

            <div class="overflow-auto">
              <b-table
                id="my-table"
                :items="items"
                :fields="fields"
                :per-page="perPage"
                :current-page="currentPage"
                primary-key="eid"
                small
              >
                <!-- A custom formatted column -->
                <template #cell(uname)="data">
                  <td>
                    <CIcon
                      :name="
                        'cif-' +
                        (data.item.user_countryNameCode
                          ? data.item.user_countryNameCode.toLowerCase()
                          : '')
                      "
                      width="40"
                    />
                    {{ data.item.uname }}
                  </td>
                </template>
                <template #cell(attachAIDs)="data">
                  <td
                    style="cursor: pointer"
                    @click="() => attachview(data.item)"
                  >
                    <CIcon
                      name="cil-paperclip"
                      width="20"
                      v-show="data.item.attachAIDs != ''"
                    />
                  </td>
                </template>
              </b-table>
              <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                aria-controls="my-table"
                style="float: right"
              ></b-pagination>
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <CModal
      :show.sync="visibleAttachView"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Attached Files"
      color="dark"
    >
      <b-carousel
        id="carousel-1"
        v-model="slide"
        :interval="4000"
        controls
        indicators
        background="#ababab"
        img-width="200"
        img-height="200"
        style="text-shadow: 1px 1px 2px #333"
        @sliding-start="onSlideStart"
        @sliding-end="onSlideEnd"
      >
        <!-- Text slides with image -->
        <b-carousel-slide
          :img-src="path"
          v-for="path in attachPaths"
          :key="path"
        ></b-carousel-slide>
      </b-carousel>
      <template #header>
        <h6 class="modal-title">Attached Files</h6>
        <CButtonClose @click="visibleAttachView = false" class="text-white" />
      </template>
      <template #footer>
        <div></div>
      </template>
    </CModal>
  </div>
</template>

<script>
import firebase from "firebase";

import {
  timeConverter,
  from_0,
  to_24,
  getDateLabel,
} from "../../common-functions.js";
import * as Const from "../../const.js";

import PageTitle from "../component/PageTitle.vue";
import SubNav from "../component/SubNav.vue";

export default {
  name: "Entries",
  components: { PageTitle, SubNav },
  data() {
    return {
      visibleAttachView: false,
      attachPaths: [],
      slide: 0,
      sliding: null,
      currentPage: 1,
      perPage: Const.perPage,
      items: [],
      fields: [
        {
          key: "entryDate",
          label: "Entry Date",
          _classes: "font-weight-bold",
          sortable: true,
        },

        { key: "uname", label: "User", sortable: true },
        { key: "bname", label: "Business Name", sortable: true },
        { key: "bcardname", label: "Business Card Name", sortable: true },
        { key: "btype", label: "Business Type", sortable: true },
        { key: "bmobile", label: "Business Mobile", sortable: true },
        { key: "cname", label: "Customer", sortable: true },
        {
          key: "customerPhoneNumber",
          label: "Customer Phone",
          sortable: true,
        },
        { key: "customerType", label: "Customer Type", sortable: true },

        {
          key: "amountGave",
          label: "Gave",
          _classes: "font-weight-bold",
          sortable: true,
        },
        {
          key: "amountGot",
          label: "Got",
          _classes: "font-weight-bold",
          sortable: true,
        },
        { key: "detail", label: "Detail", sortable: true },
        { key: "attachAIDs", label: "Attach" },

        { key: "createdAt", label: "Created At", sortable: true },
        { key: "updatedAt", label: "updated At", sortable: true },
      ],

      activePage: 1,
    };
  },
  computed: {
    rows() {
      return this.items.length;
    },
    need_refresh() {
      return (
        this.$store.state.selcountryCode +
        (this.$store.state.showSubNav.user
          ? "-" + this.$store.state.seluid
          : "") +
        (this.$store.state.showSubNav.business
          ? "-" + this.$store.state.selbid
          : "") +
        (this.$store.state.showSubNav.customer
          ? "-" + this.$store.state.selcid
          : "") +
        (this.$store.state.showSubNav.date
          ? "-" + getDateLabel(this.$store.state.from, this.$store.state.to)
          : "")
      );
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        if (route.query && route.query.page) {
          this.activePage = Number(route.query.page);
        }
      },
    },
  },
  watch: {
    need_refresh: {
      immediate: true,
      handler(value) {
        this.load("data");
      },
    },
  },
  created() {
    this.$store.commit("set", [
      "showSubNav",
      { user: true, business: true, customer: true, date: true },
    ]);
  },

  methods: {
    load(type) {
      const db = firebase.firestore();

      if (type == "data") {
        var ref = db.collection("entry");
        //if (this.seluid == "") return;
        this.$store.commit("set", ["loading_data", true]);
        if (this.$store.state.from != "")
          ref = ref.where("entryDate", ">=", from_0(this.$store.state.from));
        if (this.$store.state.to != "")
          ref = ref.where("entryDate", "<=", to_24(this.$store.state.to));

        if (this.$store.state.seluid != "")
          ref = ref.where("uid", "==", this.$store.state.seluid);
        if (this.$store.state.selbid != "")
          ref = ref.where("bid", "==", this.$store.state.selbid);
        if (this.$store.state.selcid != "")
          ref = ref.where("cid", "==", this.$store.state.selcid);
        if (this.$store.state.selcountryCode != "")
          ref = ref.where(
            "userCountryNameCode",
            "==",
            this.$store.state.selcountryCode
          );
        try {
          ref
            .where("isDeleted", "==", false)
            .orderBy("entryDate", "desc")
            //.limit(30)
            .get()
            .then((querySnapshot) => {
              this.items = [];
              this.page = 0;

              querySnapshot.forEach((doc) => {
                var entry = {
                  entryDate: timeConverter(doc.data().entryDate.seconds),
                  eid: doc.id,
                  uname: doc.data().userPhoneNumber,
                  user_countryNameCode: doc.data().userCountryNameCode,
                  uid: doc.data().uid,
                  cid: doc.data().cid,
                  cname: doc.data().customerName,
                  bid: doc.data().bid,
                  bname: doc.data().businessName,
                  bcardname: doc.data().businessCardName,
                  btype: doc.data().businessCardType,
                  bmobile: doc.data().businessCardMobile,
                  attachAIDs:
                    (doc.data().photos && doc.data().photos.length > 0) ||
                    (doc.data().attachAIDs && doc.data().attachAIDs.length > 0)
                      ? doc.id
                      : "",
                  detail: doc.data().detail,

                  customerPhoneNumber: doc.data().customerPhoneNumber,
                  customerType:
                    doc.data().customerType == 1 ? "Supplier" : "Customer",

                  amountGave: doc.data().amountGave,
                  amountGot: doc.data().amountGot,
                  amountSumGave: doc.data().amountSumGave,
                  amountSumGot: doc.data().amountSumGot,
                  createdAt: timeConverter(doc.data().createdAt.seconds),
                  updatedAt: timeConverter(doc.data().updatedAt.seconds),
                };
                this.items.push(entry);
              });
              this.$store.commit("set", ["loading_data", false]);
            });
        } catch (e) {
          this.$store.commit("set", ["loading_data", false]);
        } finally {
        }
      }
    },
    rowClicked(item, index) {
      // this.$router.push({ path: `businesses/${this.items[index].uid}` });
    },
    pageChange(val) {
      this.$router.push({ query: { page: val } });
    },

    attachview(item) {
      console.log("-- attach view here--", item);
      var db = firebase.firestore();

      db.collection("attach")
        .where("uid", "==", item.uid)
        .where("bid", "==", item.bid)
        .where("cid", "==", item.cid)
        .where("eid", "==", item.eid)
        .get()
        .then((querySnapshot) => {
          // console.log(querySnapshot);
          this.attachPaths = [];
          querySnapshot.forEach((doc) => {
            if (doc.exists) {
              this.attachPaths.push(doc.data().storeURL);
            } else {
              console.log("No such Business document!");
            }
          });
          this.visibleAttachView = true;
        })
        .catch((error) => {
          console.log("Error getting document 3:", error);
        });
    },
    csv_export() {
      let csvContent = "";
      var header = [
        "Entry date",
        "User",
        "Business Name",
        "Business Card Name",
        "Business Type",
        "Business Mobile",

        "Customer",
        "Gave",
        "Got",
        "Detail",
        "created_at",
        "updated_at",
      ];
      var universalBOM = "\uFEFF";
      let row = header.join(",");
      csvContent += row + "\r\n";

      this.items.forEach(function (row) {
        var row_str = "";
        row_str += '"' + row.entryDate + '",';
        row_str += '"' + row.uname + ' ",';
        row_str += '"' + row.bname + '",';
        row_str += '"' + row.bcardname + '",';
        row_str += '"' + row.btype + '",';
        row_str += '"' + row.bmobile + '",';
        row_str += '"' + row.cname + '",';
        row_str += '"' + row.amountGave + '",';
        row_str += '"' + row.amountGot + '",';
        row_str += '"' + row.detail + '",';
        row_str += '"' + row.createdAt + '",';
        row_str += '"' + row.updatedAt + '",';

        csvContent += row_str + "\r\n";
      });
      var universalBOM = "\uFEFF";
      var a = window.document.createElement("a");
      a.setAttribute(
        "href",
        "data:text/csv; charset=utf-8," +
          encodeURIComponent(universalBOM + csvContent)
      );
      a.setAttribute("download", "entries" + this.need_refresh + ".csv");
      window.document.body.appendChild(a);
      a.click();
    },
    onSlideStart(slide) {
      this.sliding = true;
    },
    onSlideEnd(slide) {
      this.sliding = false;
    },
  },
};
</script>
